export default __webpack_public_path__ + "static/media/ablalogo.18a3ade9.png";